import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
import tempStorage from 'usage-tracker-core/containers/tempStorage';
import { hamplitudeKey } from 'usage-tracker-core/storageKeys';
import { UUID_URL_PARAM } from './constants';

/**
 * Writes the given UUID as the `uuid` query parameter and updates the URL via
 * the router's history so the ID is available to downstream pages.
 */
export const setUuidOnUrl = (uuid, searchParams, history) => {
  searchParams.set(UUID_URL_PARAM, uuid);
  const hash = history.location.hash;
  history.replace(`${history.location.pathname}?${searchParams}${hash}`);
};

/**
 * Removes the `uuid` query parameter from the URL and returns the value that
 * was there, or `undefined` if the parameter was absent (in which case the
 * URL is left unchanged).
 */
export const removeUuidFromUrl = (searchParams, history) => {
  const uuid = searchParams.get(UUID_URL_PARAM) || undefined;
  if (uuid !== undefined) {
    searchParams.delete(UUID_URL_PARAM);
    const qs = searchParams.toString();
    const hash = history.location.hash;
    history.replace(`${history.location.pathname}${qs ? `?${qs}` : ''}${hash}`);
  }
  return uuid;
};

/**
 * When switching away from an anonymous session, clears both the authenticated
 * localStorage entry (if its `device_id` matches the anonymous UUID) and the
 * anonymous sessionStorage entry so the next authenticated session starts fresh.
 */
export const resetAmplitudeStorageIfNeeded = deviceId => {
  try {
    var _tempStorage$getItem;
    if ((_tempStorage$getItem = tempStorage.getItem(hamplitudeKey)) !== null && _tempStorage$getItem !== void 0 && _tempStorage$getItem.includes(deviceId)) {
      tempStorage.removeItem(hamplitudeKey);
    }
  } catch (_unused) {
    // noop
  }
  try {
    anonymousStorage.removeItem(hamplitudeKey);
  } catch (_unused2) {
    // noop
  }
};